import React from "react";
import DOMPurify from 'dompurify';

import GlobalContext from "./GlobalContext";

function FAQBlock(props){
  const global = React.useContext(GlobalContext);

  let tileClass = 'block faq';
  if(global.state.selected === props.id) tileClass += ' active';

  const onClick = () => global.actions.selectTile(props.id);

  return (
    <div className={ tileClass }>
      <div 
        className="toggle"
        onClick={ onClick } />
      <div>
        <h2 
          className="title"
          role="button"
          dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.title) }}
          onClick={ onClick } 
        />
        <div 
          className="content"
          dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.content) }} 
        />
      </div>
    </div>
  );
}

export default FAQBlock;